export default __webpack_public_path__ + "assets/information-40b50c854a11a46725ca2c543da34f98.svg";